export default __webpack_public_path__ + "static/media/brand.1e52b8c1.svg";